import { createSlice } from '@reduxjs/toolkit'
import { WalletState } from './types'
import {
  getPrizeWinnings,
  initiatePayPalConnect,
  disconnectPayPal,
} from './actions'

const initialState: WalletState = {
  prizeWinnings: [],
  summary: null,
  isLoading: false,
  error: null,
  message: null,
  paypalConnectUrl: null,
}

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    clearMessage: (state) => {
      state.message = null
      state.error = null
    },
  },
  extraReducers: (builder) => {
    // Get Prize Winnings
    builder.addCase(getPrizeWinnings.pending, (state) => {
      state.isLoading = true
      state.error = null
    })
    builder.addCase(getPrizeWinnings.fulfilled, (state, action) => {
      state.isLoading = false
      state.prizeWinnings = action.payload.winnings
      state.summary = action.payload.summary
    })
    builder.addCase(getPrizeWinnings.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload?.message || 'Failed to fetch prize winnings'
    })

    // Initiate PayPal Connect
    builder.addCase(initiatePayPalConnect.pending, (state) => {
      state.isLoading = true
      state.error = null
    })
    builder.addCase(initiatePayPalConnect.fulfilled, (state, action) => {
      state.isLoading = false
      state.paypalConnectUrl = action.payload.authUrl
    })
    builder.addCase(initiatePayPalConnect.rejected, (state, action) => {
      state.isLoading = false
      state.error =
        action.payload?.message || 'Failed to initiate PayPal connection'
    })

    // Disconnect PayPal
    builder.addCase(disconnectPayPal.pending, (state) => {
      state.isLoading = true
      state.error = null
    })
    builder.addCase(disconnectPayPal.fulfilled, (state, action) => {
      state.isLoading = false
      state.message = action.payload.message
    })
    builder.addCase(disconnectPayPal.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload?.message || 'Failed to disconnect PayPal'
    })
  },
})

export const { clearMessage } = walletSlice.actions
export default walletSlice.reducer
